/**
 * 路由守卫：未登录重定向登录页，登录后回跳原路由。
 * 对齐 admin-web-shell:SC-01。
 */
import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './SessionContext';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session } = useSession();
  const location = useLocation();

  if (!session) {
    // 记录来源路由，登录成功后回跳
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
